import { BrowserModule, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';

import { QuicklinkModule } from 'ngx-quicklink';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { IndexComponent } from './index/index.component';
import { SharedModule } from './shared/shared.module';
import { BackgroundComponent } from './background/background.component';
import { IndexLoggedinComponent } from './index-loggedin/index-loggedin.component';
import { NotFoundComponent } from './errors/not-found/not-found.component';
import { PageButtonComponent } from './index-loggedin/page-button/page-button.component';

import localeHe from '@angular/common/locales/he';
import { registerLocaleData } from '@angular/common';

import { CustomGestureConfig } from './gesture-config';

registerLocaleData(localeHe, 'he');

@NgModule({
  declarations: [
    AppComponent,
    IndexComponent,
    BackgroundComponent,
    IndexLoggedinComponent,
    NotFoundComponent,
    PageButtonComponent
  ],
  imports: [
    SharedModule.forRoot(),
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ServiceWorkerModule,
    QuicklinkModule
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'he' },
    { provide: HAMMER_GESTURE_CONFIG, useClass: CustomGestureConfig }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
